<template>
  <div type="input" :class="classes">
    <input
      class="ocean-ui-form-input"
      v-model="inputVal"
      :placeholder="placeholder"
      @change="onchange($event.target.value)"
      @focus="onFocus()"
      @blur="onBlur($event.target.value)"
    />
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';

export default {
  mixins: [themeMixins],
  props: ['value', 'placeholder'],
  data() {
    return {
      inputVal: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.inputVal = newVal;
    },
    // inputVal(newVal) {
    //   this.$emit("change", newVal);
    // },
  },
  methods: {
    onchange(id) {
      this.$emit('change', id);
    },
    onFocus() {
      this.$emit('focus');
    },
    onBlur(id) {
      this.$emit('blur', id);
    },
  },
};
</script>

<style scoped lang="scss">
input {
  border: none;
  background: none;
  outline: none;
}
.ocean-ui-form-input {
  width: 35vh;
  box-sizing: border-box;
  display: inline-block;
  height: 4.2vh;
  border-radius: 0;
  padding: 0 2vh;
  background: #fff;
  color: #666;
  border: 1px solid rgb(169, 169, 169);
  margin-bottom: 1.7vh;
  background: white;
  font-size: 1.8vh;
}
</style>
